var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserExperienceProductDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 82.28 59.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient-2);}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17{stroke:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-17{stroke-linejoin:round;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9,.cls-10,.cls-11,.cls-13,.cls-15,.cls-16,.cls-17{stroke-linecap:round;}.cls-2,.cls-3,.cls-10,.cls-11,.cls-15,.cls-17{stroke-width:.78px;}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:#2a78fb;}.cls-4,.cls-16{stroke-width:4px;}.cls-5,.cls-6,.cls-7,.cls-9,.cls-12,.cls-13,.cls-14,.cls-16{fill:none;}.cls-5,.cls-13{stroke-width:1.46px;}.cls-7{stroke-width:1.46px;}.cls-8{fill:#7da2fe;}.cls-8,.cls-9{stroke-width:2px;}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient);}.cls-12{stroke-width:1.21px;}.cls-13{stroke-dasharray:0 0 3.21 3.21;}.cls-15{fill:url(#linear-gradient-3);}.cls-16{stroke-miterlimit:10;}.cls-17{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 159.7,
    y1: 47.52,
    x2: 165.7,
    y2: 47.52,
    gradientTransform: "translate(-102.84 106.05) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 129.7,
    y1: 17.52,
    x2: 135.71,
    y2: 17.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 175.16,
    y1: 32.99,
    x2: 181.17,
    y2: 32.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 144.7,
    y1: 2.53,
    x2: 150.71,
    y2: 2.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 159.7,
    y1: 17.52,
    x2: 165.7,
    y2: 17.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 60.85,
    y1: 21.92,
    x2: 66.85,
    y2: 21.92,
    gradientTransform: "translate(-39.25 8.7)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3.39,24.6C3.39,12.97,12.97,3.39,24.6,3.39s21.21,9.57,21.21,21.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 2.73,
    y1: 3.39,
    x2: 46.47,
    y2: 3.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 45.81,
    cy: 24.6,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3.39,
    cy: 24.6,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 46.47,
    cy: 3.39,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3.39,
    cy: 3.39,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 24.6,
    cy: 3.39,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.25 30.62 30.16 41.51 19.05 41.51 13.95 30.62 20.6 10.41 28.6 10.41 35.25 30.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 24.6,
    y1: 10.41,
    x2: 24.6,
    y2: 27.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M27.6,30.62c0-1.66-1.34-3-3-3s-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "30.99 49.66 18.21 49.66 19.05 41.51 30.16 41.51 30.99 49.66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.27,
    y1: 58.52,
    x2: 3.77,
    y2: 58.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 6.97,
    y1: 58.52,
    x2: 43.83,
    y2: 58.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 45.43,
    y1: 58.52,
    x2: 46.93,
    y2: 58.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 62.83,
    y1: 10.58,
    x2: 48.92,
    y2: 50.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 62.83,
    y1: 10.58,
    x2: 76.73,
    y2: 50.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.93 50.2 47.46 58.93 51.05 50.26 46.93 50.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "78.72 50.2 78.19 58.93 74.6 50.26 78.72 50.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 62.83,
    y1: 10.58,
    x2: 62.83,
    y2: 2.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 62.83,
    cy: 10.58,
    r: 4.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 48.09,
    y1: 33.87,
    x2: 77.69,
    y2: 33.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.03,32.35h3.09v3.06h-3.09c-.84,0-1.53-.68-1.53-1.53h0c0-.84,.68-1.53,1.53-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.19,32.35h3.09v3.06h-3.09c-.84,0-1.53-.68-1.53-1.53h0c0-.84,.68-1.53,1.53-1.53Z",
    transform: "translate(159.94 67.75) rotate(-180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 62.89,
    y1: 35.85,
    x2: 62.89,
    y2: 31.9
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserExperienceProductDesign);
export default __webpack_public_path__ + "static/media/user-experience-product-design.46e85059ddf3fc1ad94d625ed035709c.svg";
export { ForwardRef as ReactComponent };